import create from "zustand";

const useMetatagStore = create((set: any) => ({
    metatag: { route: "", title: "", description: "", keywords: "" },
    setMetatag: (data: any) => set((state: any) => ({ metatag: data })),
}));

export { useMetatagStore };
